<div class="flex">
  <div>
    <fcom-icon class="nordic-blue-900-text icon-medium" *ngIf="icon" [name]="icon" [category]="category"></fcom-icon>
  </div>
  <div class="flex-5 font-body-1 ps-xsmall-x">
    <ng-content></ng-content>
  </div>
</div>
